import { mapBoxDtoToBoxData } from '../mappers/boxMapper';
import { BoxData } from '../models/Box';
import { BoxDto } from '../models/dtos/BoxDto';
import apiClient from './apiClient';

interface ApiResponse {
  success: boolean;
  status: number;
  data: BoxDto;
}
export const fetchBoxData = async (boxId: string): Promise<BoxData> => {
  const { data: dto } = await apiClient
    .get<ApiResponse>(`/boxes/${boxId}/info`)
    .then((resp) => resp.data);
  return mapBoxDtoToBoxData(dto);
};
